import { useMemo } from 'react';
import { getPublicAppUrl, type PublicAppUrlProps } from '../helpers';

export const usePublicApplicationUrl = (props: PublicAppUrlProps) => {
  const { domain, name, type, validatorParent, showCustomDomain } = props;
  return useMemo(() => {
    return getPublicAppUrl(props);
  }, [domain, name, type, validatorParent, showCustomDomain]);
  //   const [url, setPublicUrl] = useState('');
  //   useEffect(() => {
  //     setPublicUrl(getPublicAppUrl(props));
  //   }, [domain, name, type, validatorParent, showCustomDomain]);
  //
  //   return url;
  // };
};
